import { baseApi } from "configs/store-query";
import { ACCOUNT } from "constants/tags";
import transformObjectToFormData from "utils/object/transform-object-to-form-data";
import {
  GetAccountSelfApiRequest,
  GetAccountSelfApiResponse,
  UploadAccountSelfFreelancerResumeApiRequest,
  UploadAccountSelfFreelancerResumeApiResponse,
  UpdateAccountSelfApiRequest,
  UpdateAccountSelfApiResponse,
} from "apis/account/types/account-self-api";
import {
  UpdateAccountSelfFreelancerProfileApiRequest,
  UpdateAccountSelfFreelancerProfileApiResponse,
  UpdateAccountSelfFreelancerEmploymentApiRequest,
  UpdateAccountSelfFreelancerEmploymentApiResponse,
  UpdateAccountSelfFreelancerInformationApiRequest,
  UpdateAccountSelfFreelancerInformationApiResponse,
  UpdateAccountSelfFreelancerContactApiRequest,
  UpdateAccountSelfFreelancerContactApiResponse,
  UpdateAccountSelfFreelancerServiceApiRequest,
  UpdateAccountSelfFreelancerServiceApiResponse,
} from "apis/account/types/account-self-freelancer-section-api";

const BASE_PATH = "/accounts/self";

export const accountSelfController = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getAccountSelf: build.query<
      GetAccountSelfApiResponse,
      GetAccountSelfApiRequest
    >({
      query: (config) => ({
        url: `${BASE_PATH}`,
        method: "GET",
        ...config,
      }),
      providesTags: [ACCOUNT],
    }),
    updateAccountSelf: build.mutation<
      UpdateAccountSelfApiResponse,
      UpdateAccountSelfApiRequest
    >({
      query: (config) => ({
        url: `${BASE_PATH}`,
        method: "PUT",
        ...config,
      }),
      invalidatesTags: [ACCOUNT],
    }),
    updateAccountSelfFreelancerProfile: build.mutation<
      UpdateAccountSelfFreelancerProfileApiResponse,
      UpdateAccountSelfFreelancerProfileApiRequest
    >({
      query: (config) => ({
        url: `${BASE_PATH}/freelancer/profile`,
        method: "PUT",
        ...config,
      }),
      invalidatesTags: [ACCOUNT],
    }),
    updateAccountSelfFreelancerEmployment: build.mutation<
      UpdateAccountSelfFreelancerEmploymentApiResponse,
      UpdateAccountSelfFreelancerEmploymentApiRequest
    >({
      query: (config) => ({
        url: `${BASE_PATH}/freelancer/employment`,
        method: "PUT",
        ...config,
      }),
      invalidatesTags: [ACCOUNT],
    }),
    updateAccountSelfFreelancerInformation: build.mutation<
      UpdateAccountSelfFreelancerInformationApiResponse,
      UpdateAccountSelfFreelancerInformationApiRequest
    >({
      query: (config) => ({
        url: `${BASE_PATH}/freelancer/information`,
        method: "PUT",
        ...config,
      }),
      invalidatesTags: [ACCOUNT],
    }),
    updateAccountSelfFreelancerContact: build.mutation<
      UpdateAccountSelfFreelancerContactApiResponse,
      UpdateAccountSelfFreelancerContactApiRequest
    >({
      query: (config) => ({
        url: `${BASE_PATH}/freelancer/contact`,
        method: "PUT",
        ...config,
      }),
      invalidatesTags: [ACCOUNT],
    }),
    updateAccountSelfFreelancerService: build.mutation<
      UpdateAccountSelfFreelancerServiceApiResponse,
      UpdateAccountSelfFreelancerServiceApiRequest
    >({
      query: (config) => ({
        url: `${BASE_PATH}/freelancer/service`,
        method: "PUT",
        ...config,
      }),
      invalidatesTags: [ACCOUNT],
    }),
    uploadFreelancerResume: build.mutation<
      UploadAccountSelfFreelancerResumeApiResponse,
      UploadAccountSelfFreelancerResumeApiRequest
    >({
      query: (config) => ({
        ...config,
        url: `${BASE_PATH}/freelancer/resume`,
        method: "POST",
        body: transformObjectToFormData(config.body),
      }),
      invalidatesTags: [ACCOUNT],
    }),
  }),
});
